import { render, staticRenderFns } from "./weekdayServices.vue?vue&type=template&id=627376c9&scoped=true&"
import script from "./weekdayServices.vue?vue&type=script&lang=js&"
export * from "./weekdayServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627376c9",
  null
  
)

export default component.exports